<template>
    <Modal v-model="passThroughValue" :title="this.$i18n.t(opts.headline)" :customerConfig="customerConfig" :showCloseButton="showCloseButton" class="exit-modal">
      <div tabindex="-1">
        <p>
          {{ $t(opts.introduction) }}
        </p>
        <section class="row confirm-exit">
          <div class="col">
            <button
              v-bind:style="{ backgroundColor: theme.primaryColor }"
              ref="closeExit"
              @click="confirm();"
              @keydown="confirmByKeydown($event);"
              aria-label="close dialog"
            >
            {{ $t(opts.button) }}

            </button>
          </div>
        </section>
      </div>
    </Modal>
  </template>

<script>
import Modal from './Modal.vue';
import defaultTheme from '../../styles/defaultTheme';

export default {
  name: 'modal-exit',
  components: { Modal },
  props: ['value', 'customerConfig', 'opts'],
  inject: {
    program: 'program',
    theme: { default: defaultTheme },
  },
  data() {
    return {
      passThroughValue: false,
      showCloseButton: false,
    };
  },
  watch: {
    value() {
      this.passThroughValue = this.value;
    },
    passThroughValue() {
      this.$emit('input', this.passThroughValue);
    },
  },
  mounted() {
    this.passThroughValue = this.value;
  },
  methods: {
    confirm() {
      this.opts.modalSubmit();
    },
    confirmByKeydown(evt) {
      if ((evt.key === 'Enter') || (evt.key === 'Space') || (evt.key === ' ')) {
        this.confirm();
      }
    },
  },
};

</script>

  <style lang="scss">

  .exit-modal {

    p {
      font-size: 14px;
      margin: 9px 0 9px 0;
    }

    @media (max-width: 576px) {
      p {
        margin: 9px 38px 20px 38px;
        font-size: 14px;
      }
    }

    .row.confirm-exit {
      text-align: center;
      width: auto;

      @media (max-width: 576px) {
        padding: 0 24px;

        p {
          @media (max-width: 576px) {
            display: none;
          }
        }

      }

      .col {
        button {
          min-width: 35%;

          @media (max-width: 576px) {
            margin: 8px 0;
            width: 100%;
          }
          &:focus {
            outline: 2px solid #000;
          }
        }

      }

    }
  }
  </style>
